<div class="form-footer">
  <button
    mat-flat-button
    color="primary"
    class="button--tertiary"
    [disabled]="!formStateService.isDirty()"
    (click)="onSaveClick()">
   {{ "Speichern" | translate : "label-save"}}
  </button>

		@if(formStateService.isDirty()){
			<button
    mat-flat-button
    class="button--surface"
    (click)="onCancelClick()">
    {{ "Abbrechen" | translate : "label-cancel"}}
  </button>
		}
</div>

<ng-template #discardTpl>
  <app-confirmation-dialog
    [title]="'Änderungen verwerfen?' | translate:'title-discard-changes'"
    [message]="'Sie haben ungespeicherte Änderungen. Möchten Sie diese wirklich verwerfen?' | translate:'paragraph-discard-changes'"
    [confirmText]="'Verwerfen' | translate:'action-discard'"
    [cancelText]="'Abbrechen' | translate:'action-abort'"
  />
</ng-template>
